// Deprecated - replaced by offer.page.ts

import {ChangeDetectorRef, Component, OnInit, Input} from "@angular/core";
import {NotificationService} from "~/app/core/notification.service";
import {ApiService} from "~/app/core/api.service";
import * as Log from "~/app/core/log";
import {OfferThumbnailInfo} from "~/app/core/model/offer-thumbnail-info";
import {OfferInfo} from "~/app/core/model/offer-info";
import {OfferService} from "~/app/core/offer-service/offer.service";

@Component({
    selector: "large-offer-view",
    templateUrl: "./large-offer-view.component.html",
    styleUrls: ["./large-offer-view.component.scss"]
})
export class LargeOfferViewComponent implements OnInit {
  @Input() offer: OfferInfo;
  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly offerService: OfferService
  ) {
  }

  ngOnInit(): void {
    console.log("LargeOfferViewComponent.ngOnInit");
  }

  public getCity(offerInfo: OfferInfo) {
    for (let address of offerInfo.addresses) {
      return address.city + " ?mi";
    }
  }

  public setFavorite() {
    this.offerService.favoriteOffer(this.offer.id);
    this.offer.favorite = true;
    console.log("TODO update 'My Favorites' list");
  }

  public unsetFavorite() {
    this.offerService.unfavoriteOffer(this.offer.id);
    this.offer.favorite = false;
  }
}
